<div
  class="modal fade"
  id="ocausDocument"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Document Upload</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <img [src]="img" *ngIf="img" />
          <ngx-loading [show]="isLoading"></ngx-loading>
        </div>

        <div style="width: 99%; min-height: 470px" class="text-center"></div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn_primary"
          type="button"
          class="close"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="col-12"
  *ngIf="isLoading"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
  "
>
  <app-progress></app-progress>
</div>

<div class="ocas_questionnaire_page" *ngIf="!showQuestionData">
  <div class="inner_wrapper">
    <!-- <div>
      <h1 class="page_heading">Carrier Account</h1>

    </div>
    <p class="subheading">
      Please answer the following questions about your management systems. If
      you answer yes, please provide an explanation and documentary evidence
      using the document upload features.
    </p> -->
    <p class="subheading year">Year 2023-2024</p>

    <form
      [formGroup]="questionnairesForm"
      *ngIf="questionnaires && questionnaires.length"
      (ngSubmit)="questionnairesHandler()"
    >
      <ul class="questions_list">
        <li
          class="question_list_item"
          *ngFor="let question of questionnaires.controls; let i = index"
        >
          <div class="header">
            <span class="ques">QUESTION -</span>
            {{ questionsData[i]?.Ocas_Type?.description }}
          </div>
          <ng-container [formGroup]="question">
            <div class="radio_buttons_wrapper">
              <div class="radio_btn_wrap">
                <input
                  type="radio"
                  [value]="'YES'"
                  formControlName="answer"
                  (change)="handleYesAnswer($event, i)"
                  disabled
                />
                <label for="yes">YES</label>
              </div>
              <div class="radio_btn_wrap">
                <input
                  (change)="handleNoAnswer($event, i)"
                  type="radio"
                  [value]="'NO'"
                  formControlName="answer"
                  disabled
                />
                <label for="no">NO</label>
              </div>
            </div>

            <div
              *ngIf="question.controls.answer.value == 'YES'"
              class="question_body"
            >
              <textarea
                name="clarification"
                id="clarification"
                class="form-control textarea"
                formControlName="note"
                placeholder="Enter clarification"
                rows="10"
                [readonly]="true"
              ></textarea>
              <div>
                <div class="uploaded_files_wrapper">
                  <h2>
                    Files Uploaded ({{
                      getTotalFiles(
                        showDocument,
                        questionsData[i].Ocas_Type.id
                      )
                    }})
                  </h2>
                  <ul class="uploaded_files_list">
                    <ng-container *ngFor="let data of showDocument">
                      <li
                        *ngIf="
                          questionsData[i].Ocas_Type.id === data?.Ocas_Type.id
                        "
                      >
                        <ng-container>
                          <span class="name">
                            {{ data?.Document.file_name }}
                          </span>
                          <span class="type">
                            {{
                              data?.Document.ocument_type != null
                                ? data?.Document.ocument_type
                                : "PDF"
                            }}</span
                          >
                          <!-- <span class="file_size">{{
                      file | fileDetails : "SIZE"
                    }}</span> -->
                          <div class="actions">
                            <button
                              data-toggle="modal"
                              data-target="#ocausDocument"
                              aria-label="View file"
                              type="button"
                              class="btn_icon"
                              aria-label="View file"
                              (click)="
                                viewDoc(
                                  data?.Document.document_link,
                                  data?.Document.file_name
                                )
                              "
                            >
                              <img src="assets/visibility.png" alt="" />
                            </button>
                            <!-- <button
                              (click)="removeUploadedFile(data?.Document)"
                              type="button"
                              class="btn_icon"
                              aria-label="Delete file"
                            >
                              <img
                                style="height: 14px"
                                src="assets/delete.png"
                                alt=""
                              />
                            </button> -->
                          </div>
                        </ng-container>
                      </li>
                    </ng-container>
                  </ul>
                </div>
                <!-- end -->
              </div>
            </div>
          </ng-container>
        </li>
      </ul>
      <!-- <div class="action_btns">
        <div class="btn_wrap">
          <button type="button" class="btn btn_secondary" (click)="backList()">
            Back
          </button>
        </div>
        <div class="btn_wrap">
          <button type="submit" class="btn btn_primary">Save</button>
        </div>
      </div> -->
    </form>
  </div>
</div>
<div *ngIf="showQuestionData">
  <span class="text-info text-small" style="color: #274c9c !important"
    ><b>No data found.</b></span
  >
</div>
